import { colors } from '../variables';
import { ThemeType } from './default';
import { hexToRgbaString } from '../../src/color-utils';

const darkTheme: ThemeType = {
  bg: {
    primary: '#404040',
    secondary: colors.darkGray4,
    overlay: '#000',
    productCompare: colors.yellow3,
    productCompareLight: hexToRgbaString(colors.yellow3, 0.05),
  },
  header: {
    bg: colors.lightBlue1,
    fg: colors.white,
  },
  footer: {
    bg: {
      primary: colors.lightBlue3,
      secondary: colors.lightGray1,
    },
    fg: {
      primary: colors.semiWhite,
    },
  },
  text: {
    primary: 'white',
    secondary: '#eee',
    tertiary: '#bbb',
    quaternary: '#aaa',
    linkExternal: colors.lightBlue3,
    linkExternalHover: colors.green1,
    linkInternal: colors.white,
    linkInternalHover: colors.white,
    callToAction: colors.lightBlue1,
    callToActionHover: colors.green1,
    negative: colors.red1,
  },
  icons: {
    primary: colors.darkGray4,
    secondary: colors.darkGray2,
    tertiary: colors.mediumGray1,
    quaternary: colors.lightGray2,
    light: colors.mediumGray2,
    callToAction: colors.lightBlue3,
    callToActionHover: colors.green1,
    positive: colors.green1,
    negative: colors.red1,
  },
  lines: {
    primary: '#303030',
    secondary: '#202020',
    tertiary: '#101010',
    quaternary: '#000',
    highlight: colors.lightBlue3,
    groupHeader: colors.yellow3,
  },
  buttons: {
    primary: {
      bg: colors.lightBlue3,
      bgActive: hexToRgbaString(colors.lightBlue1, 0.2),
      text: colors.white,
      textHover: colors.white,
    },
    secondary: {
      bg: colors.darkGray1,
      text: colors.white,
      textHover: colors.white,
    },
    tertiary: {
      bg: colors.darkGray4,
      text: colors.white,
      textHover: colors.white,
    },
    quarternary: {
      bg: colors.darkBlue1,
      text: colors.white,
      textHover: colors.white,
    },
    positive: {
      bg: colors.darkGreen1,
      text: colors.white,
      textHover: colors.white,
    },
    negative: {
      bg: colors.red1,
      text: colors.white,
      textHover: colors.white,
    },
    link: {
      bg: 'transparent',
      text: colors.lightBlue3,
      textHover: colors.green1,
    },
    disabled: {
      bg: colors.darkGray1,
      text: colors.white,
      textHover: colors.white,
    },
    category: {
      bg: '#404040',
      bgActive: colors.darkGray4,
      text: colors.white,
      textHover: colors.semiWhite,
    },
    panning: {
      bg: 'rgba(0, 0, 0, 0.6)',
      bgHover: 'rgba(0, 0, 0, 0.4)',
      text: colors.white,
    },
  },
  pill: {
    primary: {
      bg: colors.lightBlue3,
      text: colors.white,
    },
    inverted: {
      bg: colors.white,
      text: colors.darkBlue1,
    },
  },
  inputs: {
    primary: {
      bg: colors.white,
      border: colors.darkGray1,
      borderFocus: colors.lightBlue2,
    },
  },
  dropdowns: {
    primary: {
      bg: colors.white,
      hoverBackground: hexToRgbaString(colors.lightBlue3, 0.2),
      borderRadius: '5px',
      borderColor: {
        active: colors.darkBlue1,
        inactive: colors.darkBlue1,
      },
    },
    secondary: {
      bg: colors.white,
      hoverBackground: hexToRgbaString(colors.lightBlue3, 0.2),
      borderRadius: 0,
      borderColor: {
        active: colors.lightGray1,
        inactive: 'transparent',
      },
    },
  },
  placeholders: {
    bg: colors.semiWhite,
    fg: colors.lightGray2,
  },
  cookieBanner: {
    bg: hexToRgbaString(colors.darkBlue1, 0.9),
    fg: colors.white,
  },
  actionBar: {
    bg: colors.darkBlue1,
    fg: colors.white,
    boxShadow: '0 -2px 10px 0 rgba(0, 0, 0, 0.2)',
  },
  ratings: {
    positive: { bg: colors.green4, fg: colors.green3 },
    neutral: { bg: colors.yellow5, fg: colors.yellow4 },
    negative: { bg: colors.red4, fg: colors.red3 },
    disabled: { bg: colors.lightGray1, fg: colors.darkGray2 },
  },
};

export default darkTheme;
